import { render, staticRenderFns } from "./BookingsList.vue?vue&type=template&id=3bbfb3c5"
import script from "./BookingsList.vue?vue&type=script&lang=js"
export * from "./BookingsList.vue?vue&type=script&lang=js"
import style0 from "./BookingsList.vue?vue&type=style&index=0&id=3bbfb3c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports